"use client";

import { useQuery } from "@tanstack/react-query";
import { getProfile, type ProfileResponse } from "../api";

export function useProfile(options?: { initialData?: ProfileResponse; enabled?: boolean }) {
  return useQuery<ProfileResponse>({
    queryKey: ["profile"],
    queryFn: getProfile,
    enabled: options?.enabled,
    initialData: options?.initialData,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
